// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__bbfZ7","gfeWrapper":"CalendarEvent_gfeWrapper__2G-Ln"};